import { useTranslate } from '@tolgee/react';
import { LogItemProps } from '../LogItemLayout';
import { useMemoizedFn } from 'ahooks';
import { useGetTaskName } from 'views/Aide/Scenario/TaskTable';
import { useMemo } from 'react';

export const useTitle = (data: LogItemProps['data']) => {
  const { t } = useTranslate();
  const { operateType, taskName, changeField, changeDetail } = data;
  const { getTaskName } = useGetTaskName();

  const formatTaskName = useMemo(() => getTaskName(taskName), [taskName, getTaskName]);

  const renderChange = useMemoizedFn(() => {
    let title;
    switch (changeField) {
      case 'TASK_ENABLE': {
        // 任务开关
        title = changeDetail?.after
          ? t('TaskOperationLog.updateTaskOpen', { name: formatTaskName })
          : t('TaskOperationLog.updateTaskClose', { name: formatTaskName });
        break;
      }
      case 'TASK_NAME': {
        // 任务名称
        title = t('TaskOperationLog.updateTaskName', { name: formatTaskName });
        break;
      }
      case 'TASK_STORE': {
        // 任务应用店铺
        title = t('TaskOperationLog.updateTaskStore', { name: formatTaskName });
        break;
      }
      case 'TASK_PRAISE_TRIGGER_POINT': {
        title = `${t('TaskOperationLog.updateTaskName', {
          name: formatTaskName,
        })} [${t('marketing.执行节点')}]`;
        break;
      }
      default: {
        // 任务过滤规则
        title = t('TaskOperationLog.updateTaskFilter', { name: formatTaskName });
        break;
      }
    }

    return title;
  });

  if (operateType === 'CREATE_TASK') {
    return t('TaskOperationLog.addTask', { name: formatTaskName });
  } else if (operateType === 'DELETE_TASK') {
    return t('TaskOperationLog.delTask', { name: formatTaskName });
  } else if (operateType === 'UPDATE_TASK') {
    return renderChange();
  } else {
    return null;
  }
};
